import { gql } from "@apollo/client";

export const CREATE_CHECKOUT_URL = gql`
  mutation create_checkout_url($contractId: String!) {
    checkoutSubscription(input: { contractId: $contractId }) {
      url
    }
  }
`;

export const CREATE_SUPPORTER_CHECKOUT_URL = gql`
  mutation supporter_create_checkout_url($contractId: String!) {
    supporterCheckoutSubscription(input: { contractId: $contractId }) {
      url
    }
  }
`;

export const GET_ORG_ID = gql`
  query orgId {
    allOrgaccount {
      edges {
        node {
          id
          pk
        }
      }
    }
  }
`;

export const GET_JOURNY_INFO = gql`
  query (
    $sdgs: [ID]
    $activityFields: [ID]
    $sdgs_pk: [Int]
    $act_pk: [Int]
    $act: [ID]
    $project_Activity_Sdgs: [ID]
    $project_Activity_ActivityFields: [ID]
    $project_Activity_Country: [ID]
    $csocollaborationneeds_Countries: [ID]
  ) {
    entireValues(sdgs: $sdgs_pk, activityfields: $act_pk)
    allSdgs {
      edges {
        node {
          pk
          id
          title
          color
          logoUrl
        }
      }
    }
    allActivityfields {
      edges {
        node {
          id
          name
          color
          pk
        }
      }
    }
    allCountries(activities_Sdgs: $sdgs, activities_ActivityFields: $act) {
      edges {
        node {
          id
          nameJp
          latitude
          longitude
          overview
          activities(sdgs: $sdgs, activityFields: $activityFields) {
            edges {
              node {
                name
                businesses
                beneficiaries
                businessCost
                countries {
                  id
                }
              }
            }
          }
        }
      }
    }
    allOrgaccount(
      orderBy: "-total_ordinary_revenue"
      project_Activity_Sdgs: $project_Activity_Sdgs
      project_Activity_ActivityFields: $project_Activity_ActivityFields
      project_Activity_Country: $project_Activity_Country
      csocollaborationneeds_Countries: $csocollaborationneeds_Countries
    ) {
      edges {
        node {
          id
          isDissolve
          pk
          name
          publicInformationScore
          reliabilityScore
          totalOrdinaryRevenue
          prefecture
          city
          street
          logoUrl
          revenueCategory {
            scale
          }
        }
      }
    }
  }
`;

export const GET_COUNTRIES_INFO = gql`
  query ($sdgsId: [ID], $activityFields: [ID]) {
    allCountries {
      edges {
        node {
          nameJp
          latitude
          longitude
          activities(sdgsId: $sdgsId, activityFields: $activityFields) {
            edges {
              node {
                name
                businesses
                beneficiaries
                businessCost
                countries {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_MARKET_DATA = gql`
  query ($project_Activity_Sdgs: [ID]) {
    allOrgaccount(
      orderBy: "-total_ordinary_revenue"
      project_Activity_Sdgs: $project_Activity_Sdgs
    ) {
      edges {
        node {
          id
          isDissolve
          pk
          name
          totalOrdinaryRevenue
          publicInformationScore
          reliabilityScore
          prefecture
          city
          street
          logoUrl
          revenueCategory {
            scale
          }
        }
      }
    }

    market {
      edges {
        node {
          year
          memberFee
          donation
          businessRevenue
          trusteeRevenue
          subsidy
          bounty
          miscellaneous
          projects
          incorporations
        }
      }
    }
  }
`;

export const GET_PROJECTNUMBER_LIST = gql`
  query ($project_Activity_Sdgs: [ID]) {
    allOrgaccount(
      orderBy: "-total_businesses"
      project_Activity_Sdgs: $project_Activity_Sdgs
    ) {
      edges {
        node {
          name
          totalBusinesses
          prefecture
          city
          street
          logoUrl
          revenueCategory {
            scale
          }
        }
      }
    }
  }
`;

export const GET_QUESTION_CATEGORY = gql`
  query ($orgId: ID!) {
    allQuetionCategory {
      edges {
        node {
          name
          quetion {
            edges {
              node {
                id
                content
                answerList
                lastAnswer(orgId: $orgId)
                orderNumber
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_TOKEN = gql`
  mutation ($email: String!, $password: String!) {
    tokenAuth(email: $email, password: $password) {
      token
    }
  }
`;

export const CREATE_USER = gql`
  mutation (
    $email: String!
    $password: String!
    $orgId: ID
    $ability: String
    $age: String
    $belongs: String
    $tension: String
    $supporterId: ID
  ) {
    createUser(
      input: {
        email: $email
        password: $password
        orgId: $orgId
        ability: $ability
        age: $age
        belongs: $belongs
        tension: $tension
        supporterId: $supporterId
      }
    ) {
      user {
        email
      }
    }
  }
`;

// export const GET_USER_INFO = gql`
// query ($email: String) {
//   userInfo(email: $email) {
//     edges {
//       node {
//         user {
//           email
//           role
//         }
//         username
//         phoneNumber
//         icon
//       }
//     }
//   }
// }
// `;

export const READ_ORG = gql`
  query ($project_Activity_Sdgs: [ID]) {
    allOrgaccount(
      orderBy: "-total_businesses"
      project_Activity_Sdgs: $project_Activity_Sdgs
    ) {
      edges {
        node {
          name
          totalBusinesses
          prefecture
          city
          street
          logoUrl
          revenueCategory {
            scale
          }
        }
      }
    }
  }
`;

export const GET_PURPOSE = gql`
  query ($id: ID!) {
    orgProfile(id: $id) {
      edges {
        node {
          purpose
        }
      }
    }
  }
`;

export const UPDATE_PURPOSE = gql`
  mutation updatePurpose($orgId: ID!, $purpose: String!) {
    updatePurpose(input: { orgId: $orgId, purpose: $purpose }) {
      org {
        id
        purpose
      }
    }
  }
`;

export const REGISTER_MAIL = gql`
  mutation ($email: String!, $orgId: ID!, $ability: String!) {
    mail(email: $email, orgId: $orgId, ability: $ability) {
      result
    }
  }
`;

export const USER_ORG_ID = gql`
  query ($email: String!) {
    allUsers(email: $email) {
      edges {
        node {
          id
          orgId
          ability
          canEditMembers
          myOrgName
          role {
            edges {
              node {
                organization {
                  id
                  pk
                  totalTicket
                  contract {
                    plan {
                      name
                      fee
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_ORG_PROFILE = gql`
  query AllOrgAcounts($fiscalYear: Int, $id: Int, $userId: ID) {
    allOrgaccount(id: $id) {
      edges {
        node {
          totalTicket
          canEditMembers
          isDissolve
          pk
          name
          id
          purpose
          logoUrl
          donationUrl
          line
          twitter
          facebook
          youtube
          tiktok
          instagram
          favPk(userId: $userId)
          totalBusinesses
          totalWorkers
          totalBeneficiaries
          totalBusinessCost
          totalOrdinaryRevenue
          newestActYear
          csocollaborationneeds {
            countries {
              edges {
                node {
                  id
                  nameJp
                }
              }
            }
            stakeholders {
              edges {
                node {
                  id
                  name
                }
              }
            }
            collaborationNeeds {
              edges {
                node {
                  id
                  title
                }
              }
            }
            activityFields {
              edges {
                node {
                  id
                  name
                }
              }
            }
          }
          # TODO
          # add another needed query for collaboration needs
          contract {
            plan {
              name
              fee
              desctiption
            }
          }
          discountProgress {
            discountAvailable #ディカウント要件に適合しているか
            latestComment #エマからのコメント
          }
          favorite(user: $userId) {
            edges {
              node {
                id
              }
            }
          }
          evaluated(userId: $userId)
          focusedIssue {
            edges {
              node {
                title
                explanation
                approach
                id
              }
            }
          }
          annualData(fiscalYear: $fiscalYear) {
            edges {
              node {
                financialStatementName
                fiscalYear

                # 収入
                memberFee
                donation
                businessRevenue
                subsidy
                bounty
                miscellaneous
                netAssetsEndYear
                totalOrdinaryRevenue
                totalOrdinaryExpenses

                # 支出
                expenceProjectPersonnel
                expenceProjectOther
                totalExpensesProject
                totalLiabilities
                expensesAdministrativeOther
                totalAdministrativeExpenses

                # 資産
                currentAssets
                fixedAssets
                totalAssets

                # 負債
                currentLiabilities
                fixedLiabilities

                # 正味財産
                totalNonOrdinaryExpenses
                totalNonOrdinaryIncome
                generalNetAssetsBeginningYear
                changeDesignatedNetAssets
                netAssets
                totalLiabilitiesNetAssets

                specificAssetUtilisation

                netDecreaseOrdinaryIncome
                netDecreaseNonOrdinary
                transferAmountAccountingCategory
                businessTax
                changeNetAssets
                generalNetAssetsBeginningYear
              }
            }
          }

          role {
            edges {
              node {
                id
                ability
                user {
                  id
                  lastName
                  firstName
                  email
                  additionalInfo {
                    username
                  }
                }
              }
            }
          }

          sdgsImages
          #tiktok
          #youtube
          #facebook
          #twitter
          #instagram
          #line
          #offices
          #representative
          #incorporationDate
          #entityNumber
          #readableEntityForm
          #entityFormNumber
          #prefecture
          #city
          #street
          #phoneNumber

          #revenueCategory {
          #  scale
          #}
          #homepage

          #socialImpact {
          #  edges {
          #    node {
          #      title
          #      reaches
          #      unit
          #      year
          #      id
          #    }
          #  }
          #}
        }
      }
    }
  }
`;

export const GET_ORG_ANNUAL_DATA = gql`
  query orgAnnualData($fiscalYear: Int, $id: Int) {
    allOrgaccount(id: $id) {
      edges {
        node {
          annualData(fiscalYear: $fiscalYear) {
            edges {
              node {
                financialStatementName
                fiscalYear

                # 収入
                memberFee
                donation
                businessRevenue
                trusteeRevenue
                subsidy
                bounty
                miscellaneous
                netAssetsEndYear
                totalOrdinaryRevenue
                totalOrdinaryExpenses

                # 支出
                expenceProjectPersonnel
                expenceProjectOther
                totalExpensesProject
                totalLiabilities
                expensesAdministrativeOther
                totalAdministrativeExpenses
                expensesAdministrativeHumanOther

                # 資産
                currentAssets
                fixedAssets
                totalAssets
                netAssetsEndYear

                # 負債
                currentLiabilities
                fixedLiabilities

                # 正味財産
                generalNetAssetsBeginningYear
                changeDesignatedNetAssets
                netAssets
                totalLiabilitiesNetAssets

                specificAssetUtilisation

                netDecreaseOrdinaryIncome
                totalNonOrdinaryIncome
                totalNonOrdinaryExpenses
                netDecreaseNonOrdinary
                transferAmountAccountingCategory
                businessTax
                changeNetAssets
                generalNetAssetsBeginningYear
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_ANNUAL_DATA = gql`
  query allAnnualData($fiscalYear: Int, $orgPk: Int, $orgPks: [Int]) {
    allAnnualData(
      orderBy: "fiscal_year"
      orgPk: $orgPk
      orgPks: $orgPks
      fiscalYear: $fiscalYear
    ) {
      edges {
        node {
          financialStatementName
          fiscalYear
          organization {
            id
          }

          # 収入
          memberFee
          donation
          businessRevenue
          subsidy
          bounty
          miscellaneous
          totalOrdinaryRevenue
          trusteeRevenue

          # 支出
          expenceProjectPersonnel
          expenceProjectOther
          totalExpensesProject
          expensesAdministrativeOther
          totalAdministrativeExpenses

          # 資産
          currentAssets
          fixedAssets
          totalAssets

          # 負債
          currentLiabilities
          fixedLiabilities
          totalLiabilities

          # 正味財産
          totalNonOrdinaryExpenses
          totalNonOrdinaryIncome
          generalNetAssetsBeginningYear
          changeDesignatedNetAssets
          netAssets
          totalLiabilitiesNetAssets

          specificAssetUtilisation
        }
      }
    }
  }
`;

export const CREATE_ISSUE = gql`
  mutation createIssue(
    $orgId: ID!
    $title: String!
    $explanation: String!
    $approach: String!
  ) {
    createIssue(
      input: {
        orgId: $orgId
        title: $title
        explanation: $explanation
        approach: $approach
      }
    ) {
      issue {
        title
        explanation
        approach
        id
      }
    }
  }
`;

export const ADD_SDGS_TO_ACTIVITY = gql`
  mutation addSdgs($activityId: ID!, $sdgsPk: Int!) {
    addActivitySdgs(input: { activityId: $activityId, sdgsId: $sdgsPk }) {
      activity {
        name
        sdgs {
          edges {
            node {
              pk
              title
              logoUrl
            }
          }
        }
      }
    }
  }
`;

export const RM_SDGS_FROM_ACTIVITY = gql`
  mutation rmSdgs($activityId: ID!, $sdgsPk: Int!) {
    deleteActivitySdgs(input: { actId: $activityId, sdgsId: $sdgsPk }) {
      act {
        name
      }
    }
  }
`;

export const UPDATE_ISSUE = gql`
  mutation updateIssue(
    $issueId: ID!
    $title: String!
    $explanation: String!
    $approach: String!
  ) {
    updateIssue(
      input: {
        issueId: $issueId
        title: $title
        explanation: $explanation
        approach: $approach
      }
    ) {
      issue {
        title
        explanation
        approach
        id
      }
    }
  }
`;

export const DELETE_ISSUE = gql`
  mutation deleteIssue($issueId: ID!) {
    deleteIssue(input: { issueId: $issueId }) {
      issue {
        id
      }
    }
  }
`;

export const CREATE_SOCIAL_IMPACT = gql`
  mutation createSocialImpact(
    $orgId: ID!
    $title: String!
    $reaches: Int!
    $unit: String!
    $year: Int!
  ) {
    createSocialImpact(
      input: {
        orgId: $orgId
        title: $title
        reaches: $reaches
        unit: $unit
        year: $year
      }
    ) {
      socialImpact {
        title
        reaches
        unit
        year
        id
      }
    }
  }
`;
export const UPDATE_SOCIAL_IMPACT = gql`
  mutation updateSocialImpact(
    $socialimpactId: ID!
    $title: String!
    $reaches: Int!
    $unit: String!
    $year: Int!
  ) {
    updateSocialImpact(
      input: {
        socialimpactId: $socialimpactId
        title: $title
        reaches: $reaches
        unit: $unit
        year: $year
      }
    ) {
      socialImpact {
        title
        reaches
        unit
        year
        id
      }
    }
  }
`;

export const DELETE_SOCIAL_IMPACT = gql`
  mutation deleteSocialImpact($socialimpactId: ID!) {
    delteSocialImpact(input: { socialimpactId: $socialimpactId }) {
      socialImpact {
        id
      }
    }
  }
`;

export const DELETE_ROLE = gql`
  mutation deleteRole($roleId: ID!) {
    deleteRole(input: { roleId: $roleId }) {
      role {
        id
      }
    }
  }
`;

export const UPDATE_BAROMETER = gql`
  mutation listBaro($orgId: Int!, $answer: [[String]]) {
    updateBarometer(input: { orgId: $orgId, answer: $answer }) {
      __typename
    }
  }
`;

export const GET_ANALYTICS_DATA = gql`
  query analyticsData($fiscalYear: Int, $orgPk: Int) {
    allAnnualData(
      orderBy: "fiscal_year"
      orgPk: $orgPk
      fiscalYear: $fiscalYear
    ) {
      edges {
        node {
          financialStatementName
          fiscalYear
          ratioNetAssetsRevenue
          revenueRatio
          administrativeExpenseRatio
          payablePeriod
          socialSupportRevenueRatioMemberDonationSubsidies
          projectRevenueRatio
          socialSupportRevenueRatioMemberDonation
          hhi

          #収入
          memberFee
          donation
          businessRevenue
          trusteeRevenue
          subsidy
          bounty
          miscellaneous
          totalOrdinaryRevenue
        }
      }
    }
    diagnoseResult(orgPk: $orgPk) {
      quetionCategory
      valueList
    }
  }
`;

//他団体比較
export const GET_COMPARISON_DATA = gql`
  query ($orgPks: [Int], $orgPk2: Int, $scaleAverageId: Int) {
    allOrgaccount {
      edges {
        node {
          id
          name
          pk
          contract {
            plan {
              name
              fee
            }
          }
        }
      }
    }

    comparisonData(orgPks: $orgPks) {
      data
      industryFiscalData
      industryDiagnoseData
    }

    revenueCategoryData(orgPk: $orgPk2, scaleAverageId: $scaleAverageId) {
      data
      specificRevenueCategoryDiagnoseAverageData
    }
  }
`;

export const GET_FINANTIAL_COMPARISON_DATA = gql`
  query ($orgPks: [Int], $orgPk2: Int, $scaleAverageId: Int) {
    comparisonData(orgPks: $orgPks) {
      data
      industryFiscalData
    }

    revenueCategoryData(orgPk: $orgPk2, scaleAverageId: $scaleAverageId) {
      data
    }
  }
`;

export const GET_DIGNOSE_COMPARISON_DATA = gql`
  query ($orgPks: [Int], $orgPk: Int, $scaleAverageId: Int) {
    comparisonData(orgPks: $orgPks) {
      industryDiagnoseData
    }

    revenueCategoryData(orgPk: $orgPk, scaleAverageId: $scaleAverageId) {
      specificRevenueCategoryDiagnoseAverageData
    }
  }
`;

export const GET_ORG_COMPARISON_DATA = gql`
  query ($orgPks: [Int], $orgPk: [Int]) {
    comparisonData(orgPks: $orgPks) {
      industryDiagnoseData
    }
    diagnoseResults(orgPk: $orgPk) {
      quetionCategory
      valueList
    }
  }
`;

export const SEARCH = gql`
  query search($context: String!, $first: Int, $offset: Int, $after: String) {
    searchOrg(
      context: $context
      first: $first
      offset: $offset
      after: $after
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          logo
          name
          prefecture
          pk
          id
          isDissolve
          logoUrl
          revenueCategory {
            scale
          }
        }
      }
    }
  }
`;

export const NEW_SEARCH = gql`
  query search(
    $name: String
    $prefecture: String
    $sdgs: [ID]
    $collaborationNeeds: [ID]
    $country: [ID]
    $activityFields: [ID]
    $stakeholders: [ID]
    $revenueCategories: [ID]
    $networks: [ID]
    $thirdPartyCertification: [ID]
    $entityForm: [String]
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $revenueCategory: ID
    $project_Activity_Countries: ID
    $project_Activity_Sdgs: [ID]
    $includeIsWished: Boolean!
  ) {
    searchOrg(
      name: $name
      prefecture: $prefecture
      sdgs: $sdgs
      collaborationNeeds: $collaborationNeeds
      country: $country
      activityFields: $activityFields
      stakeholders: $stakeholders
      revenueCategories: $revenueCategories
      networks: $networks
      thirdPartyCertification: $thirdPartyCertification
      entityForm: $entityForm
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      revenueCategory: $revenueCategory
      project_Activity_Countries: $project_Activity_Countries
      project_Activity_Sdgs: $project_Activity_Sdgs
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          logo
          name
          prefecture
          pk
          id
          isDissolve
          homepage
          logoUrl
          purpose
          publicInformationScore
          reliabilityScore
          isWished @include(if: $includeIsWished)
          revenueCategory {
            scale
          }
        }
      }
    }
  }
`;

export const GET_ORG_INFO = gql`
  query ortInfo {
    allOrgaccount {
      edges {
        node {
          logo
          name
          id
          isDissolve
          prefecture
          pk
          publicInformationScore
          reliabilityScore
          logoUrl
          revenueCategory {
            scale
          }
        }
      }
    }
  }
`;

export const GET_USER_PROF = gql`
  query allUsers($email: String!) {
    allSdgs {
      edges {
        node {
          id
          logoUrl
        }
      }
    }
    allNpoQuetionnaireItems {
      edges {
        node {
          id
          title
        }
      }
    }
    allUsers(email: $email) {
      edges {
        node {
          id
          orgId
          email
          lastName
          firstName
          iconUrl
          myOrgName
          totalTicket
          isCso
          isSupporter
          role {
            edges {
              node {
                organization {
                  totalTicket
                  id
                }
              }
            }
          }
          additionalInfo {
            username
            phoneNumber
            icon
            age
            sex
            belongs
            sdgsInterest {
              edges {
                node {
                  title
                  logoUrl
                  id
                }
              }
            }
            npoInterest {
              edges {
                node {
                  id
                  title
                }
              }
            }
          }
          hasNotice {
            hasNotice
            id
          }
        }
      }
    }

    allNotifications(first: 7) {
      edges {
        node {
          id
          title
          link
          noticedAt
        }
      }
    }
  }
`;

export const UPDATE_USERINFO = gql`
  mutation updateUserInfo(
    $email: String!
    $username: String
    $phone: String
    $age: String
    $sex: String
    $belongs: String
    $sdgsInterest: [ID]
    $npoInterest: [ID]
  ) {
    updateUserInfo(
      input: {
        email: $email
        username: $username
        phone: $phone
        age: $age
        sex: $sex
        belongs: $belongs
        npoInterest: $npoInterest
        sdgsInterest: $sdgsInterest
      }
    ) {
      userAdditionalInfo {
        username
        email
        phoneNumber
        age
        sex
        belongs
        sdgsInterest {
          edges {
            node {
              title
              logo
              logoUrl
            }
          }
        }
        npoInterest {
          edges {
            node {
              title
            }
          }
        }
      }
    }
  }
`;

export const CREATE_FAVORITE = gql`
  mutation createFav($orgId: ID!, $userId: ID!) {
    createFavorite(input: { orgId: $orgId, userId: $userId }) {
      favorite {
        id
      }
    }
  }
`;

export const DELETE_FAVORITE = gql`
  mutation deleteFav($favPk: Int!) {
    deleteFavorite(input: { favPk: $favPk }) {
      favorite {
        id
      }
    }
  }
`;

export const FAVORITE_LISTS = gql`
  query ($user: ID) {
    allFavorites(user: $user) {
      edges {
        node {
          user {
            id
          }
          org {
            id
            pk
            isDissolve
            name
            prefecture
            logoUrl
            publicInformationScore
            revenueCategory {
              scale
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_ORG_LOGO = gql`
  mutation orgLogo($image: Upload!, $userId: ID!, $orgPk: Int!) {
    updateOrgAccount(logo: $image, userId: $userId, pk: $orgPk) {
      success
    }
  }
`;

export const DELETE_ORG_LOGO = gql`
  mutation deleteOrgLogo($userId: ID!, $orgPk: Int!) {
    deleteOrgAccountLogo(userId: $userId, pk: $orgPk) {
      success
    }
  }
`;

export const UPDATE_USER_ICON = gql`
  mutation updateUserIcon($icon: Upload!, $userId: ID!) {
    updateUserIcon(icon: $icon, userId: $userId) {
      success
    }
  }
`;

export const CREATE_ROLE = gql`
  mutation createRole($email: String!, $orgId: ID!, $ability: String!) {
    createRole(input: { email: $email, orgId: $orgId, ability: $ability }) {
      role {
        id
      }
    }
  }
`;

export const CREATE_SUPPORTER_ROLE = gql`
  mutation createRole($email: String!, $supporterId: ID, $ability: String!) {
    createRole(
      input: { email: $email, supporterId: $supporterId, ability: $ability }
    ) {
      supporterRole {
        id
      }
    }
  }
`;

export const UPDATE_ORG_LINK = gql`
  mutation linkUpdate(
    $orgId: ID!
    $youtube: String
    $instagram: String
    $facebook: String
    $tiktok: String
    $twitter: String
    $line: String
    $donation: String
  ) {
    updateOrgSnsLink(
      input: {
        orgId: $orgId
        youtubeUrl: $youtube
        instagramUrl: $instagram
        donationUrl: $donation
        tiktokUrl: $tiktok
        twitterUrl: $twitter
        lineUrl: $line
        facebeookUrl: $facebook
      }
    ) {
      org {
        name
        id
        donationUrl
        youtube
        instagram
        twitter
        tiktok
        line
        facebook
      }
    }
  }
`;

export const UPDATE_ORG_PROFILE = gql`
  mutation updateOrgProfile(
    $orgId: ID!
    $userId: ID!
    $name: String
    $incorporationDate: Date
    $entityNumber: String
    $prefecture: String
    $phoneNumber: String
    $homepage: String
    $entityForm: String
    $representative: String
    $city: String
    $street: String
    $stuffNumber: Int
  ) {
    updateOrgProfile(
      input: {
        orgId: $orgId
        userId: $userId
        name: $name
        incorporationDate: $incorporationDate
        entityNumber: $entityNumber
        prefecture: $prefecture
        phoneNumber: $phoneNumber
        homepage: $homepage
        entityForm: $entityForm
        representative: $representative
        city: $city
        street: $street
        stuffNumber: $stuffNumber
      }
    ) {
      org {
        id
        donationUrl
        tiktok
        youtube
        facebook
        twitter
        instagram
        line
        offices
        representative
        incorporationDate
        entityNumber
        readableEntityForm
        entityFormNumber
        prefecture
        city
        street
        phoneNumber
        sdgsImages

        revenueCategory {
          scale
        }
        homepage
        stuffNumber
      }
    }
  }
`;

export const SEND_CONTACT = gql`
  mutation sendContact(
    $comment: String!
    $email: String!
    $name: String!
    $phoneNumber: String
    $userId: ID!
  ) {
    sendContactMessage(
      userId: $userId
      email: $email
      phoneNumber: $phoneNumber
      name: $name
      comment: $comment
    ) {
      result
    }
  }
`;

export const UPDATE_EVALUATION = gql`
  mutation updateEvaluation(
    $userId: ID!
    $orgId: ID!
    $evaluation: Int!
    $comment: String
  ) {
    updateEvaluation(
      input: {
        userId: $userId
        orgId: $orgId
        evaluation: $evaluation
        comment: $comment
      }
    ) {
      org {
        id
        name
      }
    }
  }
`;

export const READ_NOTICE = gql`
  mutation readNotice($userId: ID!) {
    readNotice(input: { userId: $userId }) {
      hasNotice
    }
  }
`;

export const READ_NOTICE_QUERY = gql`
  query notice {
    allNotifications {
      edges {
        node {
          link
          title
          noticedAt
        }
      }
    }
  }
`;

export const REPORT_SUBMIT = gql`
  mutation reportSubmit($orgId: ID!, $report: Upload, $report2: Upload) {
    reportSubmit(
      orgId: $orgId
      financialReport: $report
      activityReport: $report2
    ) {
      success
    }
  }
`;

export const CHECK_DISCOUNT_STATUS = gql`
  query myContract($id: Int) {
    allOrgaccount(id: $id) {
      edges {
        node {
          id
          name
          discountProgress {
            discountAvailable
            latestComment
          }
          contract {
            plan {
              name
              fee
              desctiption
            }
          }
        }
      }
    }
  }
`;

export const GET_ORG_REGULATION = gql`
  query getOrgRegultaions($org_id: Int) {
    regulationCategory {
      edges {
        node {
          title
          regulation {
            edges {
              node {
                id
                title
                orgRegulation(org_Id: $org_id) {
                  edges {
                    node {
                      id
                      isOpen
                      isHold
                      url
                      pdf
                      pdfName
                      org {
                        name
                        id
                      }
                      regulation {
                        title
                        category {
                          title
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_REGULATION = gql`
  mutation updateRegulation(
    $orgId: ID!
    $regulationId: ID!
    $pdf: Upload
    $is_hold: Boolean
    $is_open: Boolean
    $url: String
  ) {
    updateOrgregluationPdf(
      orgId: $orgId
      regulationId: $regulationId
      pdf: $pdf
      isHold: $is_hold
      isOpen: $is_open
      url: $url
    ) {
      success
    }
  }
`;

export const DELETE_REGULATION = gql`
  mutation deleteRegulationPdf($orgId: ID!, $orgRegulationId: ID!) {
    deleteOrgregluationPdf(orgId: $orgId, regulationId: $orgRegulationId) {
      success
      __typename
    }
  }
`;

export const ABOUT_SERVICE = gql`
  query serviceitem($about_service_item_id: ID!) {
    aboutServiceItems(aboutService: $about_service_item_id) {
      edges {
        node {
          id
          title
          aboutServiceContent {
            edges {
              node {
                title
                text
              }
            }
          }
        }
      }
    }
  }
`;

export const SERVICE_CONTENT = gql`
  query cotent($aboutServiceItem: ID) {
    aboutServiceContent(aboutServiceItem: $aboutServiceItem) {
      edges {
        node {
          title
          text
        }
      }
    }
  }
`;

export const DELETE_ACTIVITY = gql`
  mutation deleteActivity($activityId: ID!, $userId: ID!, $orgId: ID!) {
    deleteActivity(
      input: { activityId: $activityId, userId: $userId, orgId: $orgId }
    ) {
      activity {
        id
        name
      }
    }
  }
`;

export const CREATE_ACTIVITY = gql`
  mutation createActivity(
    $userId: ID!
    $orgId: ID!
    $projectId: ID!
    $name: String!
    $year: Int
  ) {
    createActivity(
      input: {
        userId: $userId
        orgId: $orgId
        projectId: $projectId
        name: $name
        year: $year
      }
    ) {
      activity {
        id
        name
        year
        project {
          name
        }
      }
    }
  }
`;

export const GET_INTEREST_QUESTIONNAIRE_ITEMS = gql`
  query sdgs {
    allSdgs {
      edges {
        node {
          id
          title
          logoUrl
        }
      }
    }
    allNpoQuetionnaireItems {
      edges {
        node {
          id
          title
        }
      }
    }
  }
`;

export const FIRST_ADD_INTEREST = gql`
  mutation first_add_interest(
    $email: String!
    $sdgsInterest: [ID]
    $npoInterest: [ID]
  ) {
    updateUserInfo(
      input: {
        email: $email
        sdgsInterest: $sdgsInterest
        npoInterest: $npoInterest
      }
    ) {
      userAdditionalInfo {
        username
        sdgsInterest {
          edges {
            node {
              title
            }
          }
        }
        npoInterest {
          edges {
            node {
              title
            }
          }
        }
      }
    }
  }
`;

export const UPD_PROJECT = gql`
  mutation updProject($project_id: ID!, $title: String!) {
    updateProject(input: { projectId: $project_id, title: $title }) {
      project {
        id
        name
      }
    }
  }
`;

export const CREATE_PROJECT = gql`
  mutation addPro($name: String!, $orgId: ID!, $userId: ID!) {
    addProject(name: $name, orgId: $orgId, userId: $userId) {
      project {
        id
        name
        teikanId
      }
    }
  }
`;

export const DELETE_PROJECT = gql`
  mutation rmPro($projectId: ID!, $orgId: ID!, $userId: ID!) {
    rmProject(
      input: { projectId: $projectId, orgId: $orgId, userId: $userId }
    ) {
      project {
        id
        name
      }
    }
  }
`;

export const UPDATE_PROJECT = gql`
  mutation updProject(
    $userId: ID!
    $orgId: ID!
    $activityId: ID!
    $activityFields: [ID]
    $beneficiaries: Int
    $businessCost: Int
    $businesses: Int
    $country: [ID]
    $name: String
    $workers: Int
    $sdgs: [ID]
    $year: Int
    $target: [ID]
  ) {
    updateActivity(
      input: {
        activityId: $activityId
        orgId: $orgId
        userId: $userId
        name: $name
        businesses: $businesses
        workers: $workers
        beneficiaries: $beneficiaries
        businessCost: $businessCost
        activityFields: $activityFields
        country: $country
        sdgs: $sdgs
        year: $year
        target: $target
      }
    ) {
      activity {
        id
        year
        name
        beneficiaries
        businesses
        country {
          edges {
            node {
              id
              nameJp
            }
          }
        }
        workers
        businessCost
        sdgs {
          edges {
            node {
              id
              logoUrl
            }
          }
        }
        activityFields {
          edges {
            node {
              id
              name
            }
          }
        }
        target {
          edges {
            node {
              name
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_ACTIVITY = gql`
  mutation updateActivity(
    $activityId: ID!
    $orgId: ID!
    $userId: ID!
    $name: String
    $year: Int
    $countries: ID
    $businesses: Int
    $workers: Int
    $beneficiaries: Int
    $businessCost: Int
    $activityFields: [ID]
    $activityFieldsDetail: [ID]
    $target: [ID]
  ) {
    updateActivity(
      activityId: $activityId
      orgId: $orgId
      userId: $userId
      name: $name
      year: $year
      countries: $countries
      businesses: $businesses
      workers: $workers
      beneficiaries: $beneficiaries
      businessCost: $businessCost
      activityFields: $activityFields
      activityFieldsDetail: $activityFieldsDetail
      target: $target
    ) {
      activity {
        name
        businesses
        activitiyFields {
          edges {
            node {
              id
              name
              color
            }
          }
        }
      }
    }
  }
`;

export const GET_ALL_COUNTRIES = gql`
  query allCountry {
    allSdgs {
      edges {
        node {
          id
          intId
          logoUrl
        }
      }
    }
    countries {
      edges {
        node {
          id
          intId
          nameJp
        }
      }
    }
    allActivityfields {
      edges {
        node {
          id
          intId
          color
          name
        }
      }
    }
    allTarget {
      edges {
        node {
          id
          intId
          name
        }
      }
    }
  }
`;

export const GET_ACTIVITY = gql`
  query activity($projectId: ID!, $year: Int) {
    allActivity(project: $projectId, year: $year) {
      edges {
        node {
          id
          year
          name
          beneficiaries
          businesses
          # countries {
          #   id
          #   nameJp
          # }
          country {
            edges {
              node {
                nameJp
                id
              }
            }
          }
          workers
          businessCost
          sdgs {
            edges {
              node {
                id
                title
                logoUrl
              }
            }
          }
          activityFields {
            edges {
              node {
                id
                name
                color
              }
            }
          }
          target {
            edges {
              node {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_PROJECTS = gql`
  query project($orgId: ID!) {
    allProject(organization: $orgId) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const GET_ORG_PROFILE_2 = gql`
  query Acounts($id: Int) {
    allOrgaccount(id: $id) {
      edges {
        node {
          id
          donationUrl
          tiktok
          youtube
          facebook
          twitter
          instagram
          line
          offices
          representative
          incorporationDate
          entityNumber
          readableEntityForm
          entityFormNumber
          prefecture
          city
          street
          phoneNumber
          sdgsImages
          newestActYear
          totalTicket
          csocollaborationneeds {
            countries {
              edges {
                node {
                  id
                  nameJp
                  nameEn
                }
              }
            }
          }
          revenueCategory {
            scale
          }
          homepage
          stuffNumber
          csonetwork {
            id
            logoUrl
            title
            url
          }
          csothirdpartycertificate {
            id
            logoUrl
            title
            url
          }
        }
      }
    }
  }
`;

export const DELETE_ORG_REGULATION = gql`
  mutation deleteOrgRegulation(
    $userId: ID!
    $orgId: ID!
    $orgRegulationId: ID!
  ) {
    deleteOrgReguration(
      input: {
        userId: $userId
        orgId: $orgId
        orgRegulationId: $orgRegulationId
      }
    ) {
      orgRegulation {
        id
        isOpen
        isHold
        pdf
        url
        org {
          name
          id
        }
        regulation {
          title
          category {
            title
          }
        }
      }
    }
  }
`;

export const QUERY_GET_ALL_TARGET = gql`
  query getTarget {
    allTarget {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const QUERY_GET_ALL_SDGS = gql`
  query allSDGs {
    allSdgs {
      edges {
        node {
          id
          title
          color
          logoUrl
        }
      }
    }
  }
`;

export const QUERY_GET_ALL_ACTS = gql`
  query allActs {
    allActivityfields {
      edges {
        node {
          name
        }
      }
    }
  }
`;

export const QUERY_GET_ALL_TARGET_AUDIENCE = gql`
  query allTargetAudience {
    allTarget {
      edges {
        node {
          name
        }
      }
    }
  }
`;

export const QUERY_GET_ALL_SCALE_OF_ORG = gql`
  query scaleOfTheOrganization {
    allRevenueCategory {
      edges {
        node {
          id
          scale
        }
      }
    }
  }
`;

export const QUERY_SEARCH_PROPS = gql`
  query allSearchProps {
    allSdgs {
      edges {
        node {
          id
          title
          color
          logoUrl
        }
      }
    }
    allActivityfields {
      edges {
        node {
          id
          name
        }
      }
    }
    allTarget {
      edges {
        node {
          id
          name
        }
      }
    }
    allRevenueCategory {
      edges {
        node {
          id
          scale
        }
      }
    }
    allCollaborationNeeds {
      edges {
        node {
          id
          title
        }
      }
    }
  }
`;

export const QUERY_ALL_USER = gql`
  query all_user($email: String!) {
    allUsers(email: $email) {
      edges {
        node {
          email
          isSupporter
          supporterRole
          ability
        }
      }
    }
  }
`;

export const QUERY_ORG_SUPPORTER = gql`
  query org_supporter {
    allSupporters {
      edges {
        node {
          name
          incorporationDate
          prefecture
          city
          phoneNumber
          representativeName
          industry
          saleScale {
            scaleLevel
          }
          stuffNumber
          overseasBranch {
            edges {
              node {
                id
                nameJp
              }
            }
          }
          focusedSdges {
            edges {
              node {
                pk
                logoUrl
                title
                id
              }
            }
          }
          homepageUrl
          csrUrl
          line
          facebook
          twitter
          tiktok
          youtube
          instagram
          officeAbroadForMap
        }
      }
    }
  }
`;

export const QUERY_ORG_SUPPORTER_MISSION = gql`
  query org_supporter_mission {
    allSupporters {
      edges {
        node {
          mission
          sustainabilityPolicy
          interestingCountry {
            edges {
              node {
                id
                nameJp
              }
            }
          }
          interestingActivity {
            edges {
              node {
                id
                name
              }
            }
          }
          collaborationNeeds {
            edges {
              node {
                id
                title
              }
            }
          }
          focusedStakeholders {
            edges {
              node {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;

export const QUERY_SPECIFIC_SUPPORTER_MISSION = gql`
  query get_specific_supporter($supporterId: ID!) {
    getSpecificSupporter(supporterId: $supporterId) {
      mission
      sustainabilityPolicy
      interestingCountry {
        edges {
          node {
            id
            nameJp
          }
        }
      }
      interestingActivity {
        edges {
          node {
            id
            name
          }
        }
      }
      collaborationNeeds {
        edges {
          node {
            id
            title
          }
        }
      }
      focusedStakeholders {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`;

export const QUERY_SUPPORTER_INFORMATION = gql`
  query supporter_information {
    allCollaborationNeeds {
      edges {
        node {
          id
          title
        }
      }
    }
    allActivity {
      edges {
        node {
          id
          name
        }
      }
    }
    allTarget {
      edges {
        node {
          id
          name
        }
      }
    }
    allSupporters {
      edges {
        node {
          mission
          sustainabilityPolicy
          interestingCountry {
            edges {
              node {
                nameJp
              }
            }
          }
          interestingActivity {
            edges {
              node {
                id
                name
              }
            }
          }
          collaborationNeeds {
            edges {
              node {
                id
                title
              }
            }
          }
          focusedStakeholders {
            edges {
              node {
                name
              }
            }
          }
        }
      }
    }
  }
`;

export const QUERY_CSO_COLLABORATION_NEEDS_FIELDS = gql`
  query get_collaboration_need_fields {
    allCollaborationNeeds {
      edges {
        node {
          id
          title
        }
      }
    }
    allActivity {
      edges {
        node {
          id
          name
        }
      }
    }
    allTarget {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const UPDATE_SUPPORTER = gql`
  mutation update_supporter(
    $incorporationDate: Date
    $prefecture: String
    $city: String
    $phoneNumber: String
    $representativeName: String
    $industry: String
    $stuffNumber: Int
    $homepageUrl: String
    $csrUrl: String
    $facebook: String
    $line: String
    $instagram: String
    $youtube: String
    $twitter: String
    $tiktok: String
    $mission: String
    $sustainabilityPolicy: String
    $saleScale: ID
  ) {
    updateSupporter(
      input: {
        incorporationDate: $incorporationDate
        prefecture: $prefecture
        city: $city
        phoneNumber: $phoneNumber
        representativeName: $representativeName
        industry: $industry
        stuffNumber: $stuffNumber
        homepageUrl: $homepageUrl
        csrUrl: $csrUrl
        facebook: $facebook
        line: $line
        instagram: $instagram
        youtube: $youtube
        twitter: $twitter
        tiktok: $tiktok
        mission: $mission
        sustainabilityPolicy: $sustainabilityPolicy
        saleScale: $saleScale
      }
    ) {
      supporter {
        name
        nameKana
        incorporationDate
        prefecture
        city
        phoneNumber
        representativeName
        industry
        stuffNumber
        homepageUrl
        csrUrl
        facebook
        line
        instagram
        youtube
        twitter
        tiktok
        mission
        sustainabilityPolicy
        saleScale {
          label
        }
      }
    }
  }
`;

export const QUERY_GET_FOREIGN_BRANCH_COUNTRIES = gql`
  query foreign_branch_countries {
    allCountries {
      edges {
        node {
          nameJp
          id
        }
      }
    }
  }
`;

export const QUERY_GET_ALL_COUNTRIES = gql`
  query foreign_branch_countries {
    countries {
      edges {
        node {
          nameEn
          nameJp
          id
        }
      }
    }
  }
`;

export const UPDATE_M2M_SUPPORTER = gql`
  mutation update_m2m_supporter(
    $focusedStakeholders: [ID]
    $overseasBranch: [ID]
    $collaborationNeeds: [ID]
    $focusedSdges: [ID]
    $interestingCountry: [ID]
    $interestingActivity: [ID]
  ) {
    updateSupporterM2mField(
      input: {
        focusedStakeholders: $focusedStakeholders
        overseasBranch: $overseasBranch
        collaborationNeeds: $collaborationNeeds
        focusedSdges: $focusedSdges
        interestingCountry: $interestingCountry
        interestingActivity: $interestingActivity
      }
    ) {
      supporter {
        collaborationNeeds {
          edges {
            node {
              title
            }
          }
        }
        focusedSdges {
          edges {
            node {
              title
              logoUrl
            }
          }
        }
        interestingActivity {
          edges {
            node {
              name
            }
          }
        }
        focusedStakeholders {
          edges {
            node {
              name
            }
          }
        }
        interestingCountry {
          edges {
            node {
              nameJp
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_M2M_SUPPORTER_OVERSEAS_BRANCH = gql`
  mutation update_m2m_supporter($overseasBranch: [ID]) {
    updateSupporterM2mField(input: { overseasBranch: $overseasBranch }) {
      supporter {
        collaborationNeeds {
          edges {
            node {
              title
            }
          }
        }
        focusedSdges {
          edges {
            node {
              title
              logoUrl
            }
          }
        }
        interestingActivity {
          edges {
            node {
              name
            }
          }
        }
        focusedStakeholders {
          edges {
            node {
              name
            }
          }
        }
        interestingCountry {
          edges {
            node {
              nameJp
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_M2M_SUPPORTER_SDGS = gql`
  mutation suppporter_collaboration_needs_upd($focusedSdges: [ID]) {
    updateSupporterM2mField(input: { focusedSdges: $focusedSdges }) {
      supporter {
        focusedSdges {
          edges {
            node {
              logoUrl
            }
          }
        }
      }
    }
  }
`;

export const QUERY_GET_SALE_SCALE = gql`
  query sale_scale {
    allSaleScale {
      edges {
        node {
          id
          label
        }
      }
    }
  }
`;

export const QUERY_GET_ALL_ACTIVITY = gql`
  query issues {
    allActivityfields {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const QUERY_GET_ALL_COLLABORATION_NEEDS = gql`
  query allCollaboratinNeeds {
    allCollaborationNeeds {
      edges {
        node {
          id
          title
        }
      }
    }
  }
`;

export const CSO_SIGNUP = gql`
  mutation send_sing_up_email($email: String) {
    sendSignUpEmail(input: { email: $email }) {
      result
    }
  }
`;

export const QUERY_GET_ALL_PUB_INFO = gql`
  query all_pub_info {
    allPublishedInformationCategory {
      edges {
        node {
          title
          publshedInformation {
            edges {
              node {
                id
                title
                supporterPublishedInfomation {
                  edges {
                    node {
                      isHold
                      isPublished
                      referenceUrl
                      pdfUrl
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const QUERY_SPECIFIC_SUPPORTER_PUB_INFO = gql`
  query get_specific_supporter($supporterId: ID!) {
    allPublishedInformationCategory {
      edges {
        node {
          title
          publshedInformation {
            edges {
              node {
                title
                supporterPublishedInfomation(
                  supporterGraphaneId: $supporterId
                ) {
                  edges {
                    node {
                      isHold
                      isPublished
                      pdfUrl
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const CREATE_OR_UPDATE_SUPPORTER_PUBLISHED_INFO = gql`
  mutation create_or_update_supporter_published_info(
    $publishedInformationId: ID!
    $isHold: Boolean
    $isPublished: Boolean
    $referenceUrl: String
  ) {
    createOrUpdateSupporterPublishedInfo(
      input: {
        publishedInformationId: $publishedInformationId
        isHold: $isHold
        isPublished: $isPublished
        referenceUrl: $referenceUrl
      }
    ) {
      supporerPublishedInformation {
        isHold
        isPublished
        referenceUrl
      }
    }
  }
`;

export const CREATE_OR_UPDATE_SUPPORTER_PUBLISHED_INFO_PDF = gql`
  mutation upload_published_info_pdf(
    $publishedInformationId: ID!
    $pdfUrl: String
  ) {
    createOrUpdateSupporterPublishedInfo(
      input: {
        publishedInformationId: $publishedInformationId
        pdfUrl: $pdfUrl
      }
    ) {
      supporerPublishedInformation {
        id
        isHold
        isPublished
        pdfUrl
      }
    }
  }
`;

export const QUERY_MY_SUPPORTER_INFO = gql`
  query my_supporter_info {
    mySupporterInfo {
      edges {
        node {
          id
          name
          logoUrl
          totalTicket
        }
      }
    }
  }
`;

export const GET_SUPPORTER_PROFILE = gql`
  query get_specific_supporter($supporterId: ID!) {
    getSpecificSupporter(supporterId: $supporterId) {
      entityForm
      entityNumber
      name
      incorporationDate
      prefecture
      city
      phoneNumber
      representativeName
      industry
      saleScale {
        scaleLevel
        __typename
      }
      stuffNumber
      overseasBranch {
        edges {
          node {
            id
            nameJp
            __typename
          }
          __typename
        }
        __typename
      }
      focusedSdges {
        edges {
          node {
            pk
            logoUrl
            title
            id
            __typename
          }
          __typename
        }
        __typename
      }
      homepageUrl
      csrUrl
      line
      facebook
      twitter
      tiktok
      youtube
      instagram
      officeAbroadForMap
      __typename
    }
    __typename
  }
`;

export const UPLOAD_PUBLISHED_INFO_PDF = gql`
  mutation upload_published_info_pdf(
    $publishedInformationId: ID!
    $pdf: Upload!
  ) {
    uploadSupporterPublishedInfoPdf(
      input: { publishedInformationId: $publishedInformationId, pdf: $pdf }
    ) {
      supprterPublishedInformation {
        id
        isHold
        isPublished
        pdfUrl
      }
    }
  }
`;

export const DELETE_SUPPORTER_PUBLISHED_INFO = gql`
  mutation deleteSupporterPublishedInfoPdf($publishedInformationId: ID!) {
    deleteSupporterPublishedInfoPdf(
      input: { publishedInformationId: $publishedInformationId }
    ) {
      supprterPublishedInformation {
        referenceUrl
      }
    }
  }
`;

export const CHECK_USER_STATUS = gql`
  query my_data($email: String) {
    allUsers(email: $email) {
      edges {
        node {
          id
          isSupporter
          isCso
          supporterRole
        }
      }
    }
  }
`;

export const QUERY_CSO_COLLABORATION_POLICY = gql`
  query cso_collaboration_policy {
    myCso {
      edges {
        node {
          purpose
          activeCountries
          stakeHolders {
            edges {
              node {
                id
                name
              }
            }
          }
          csocollaborationneeds {
            collaborationNeeds {
              edges {
                node {
                  id
                  title
                }
              }
            }
          }
          totalActivityFields {
            edges {
              node {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_SUPPORTER_LOGO = gql`
  mutation change_supporter_icon($icon: Upload!) {
    uploadSupporterIcon(input: { icon: $icon }) {
      supporter {
        id
      }
    }
  }
`;

export const UPDATE_CSO_COUNTRIES = gql`
  mutation updateCsoCollaborationInfo($countries: [ID]!) {
    updateCsoCollaborationInfo(input: { countries: $countries }) {
      csoCollaborationInfo {
        countries {
          edges {
            node {
              id
              nameJp
            }
          }
        }
      }
    }
  }
`;

export const QUERY_CSO_COLLABORATION_NEEDS = gql`
  query test {
    myCso {
      edges {
        node {
          csocollaborationneeds {
            countries {
              edges {
                node {
                  id
                  nameJp
                }
              }
            }
            stakeholders {
              edges {
                node {
                  id
                  name
                }
              }
            }
            collaborationNeeds {
              edges {
                node {
                  id
                  title
                }
              }
            }
            activityFields {
              edges {
                node {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_CSO_COLLABORATION_NEEDS = gql`
  mutation UpdateCSOCollaborationNeeds(
    $activityFields: [ID]
    $collaborationNeeds: [ID]
    $stakeholders: [ID]
    $countries: [ID]
  ) {
    updateCsoCollaborationInfo(
      input: {
        activityFields: $activityFields
        collaborationNeeds: $collaborationNeeds
        stakeholders: $stakeholders
        countries: $countries
      }
    ) {
      csoCollaborationInfo {
        collaborationNeeds {
          edges {
            node {
              id
              title
            }
          }
        }
        stakeholders {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_CSO_SDGS = gql`
  mutation updateCsoSdgsInfo($sdgs: [ID]!) {
    updateCsoSdgsInfo(input: { sdgs: $sdgs }) {
      sdgs {
        id
        title
      }
    }
  }
`;

export const GET_NPS_INFO = gql`
  query getNPSInfo {
    nps {
      age
      sex
      comment
      createdAt
    }
    totalFavoriteNumber
    totalFavoriteNumberPerEvaluation
  }
`;

export const GET_TICKET_PACKAGES = gql`
  query allTicket {
    allTicket {
      edges {
        node {
          id
          stripePriceId
          amount
          price
        }
      }
    }
  }
`;

export const USER_CHECKOUT_TICKET = gql`
  mutation userCheckoutTicket($ticketId: ID!) {
    userCheckoutTicket(input: { ticketId: $ticketId }) {
      url
    }
  }
`;

export const CSO_CHECKOUT_TICKET = gql`
  mutation csoCheckoutTicket($ticketId: ID!, $orgId: ID!) {
    csoCheckoutTicket(input: { ticketId: $ticketId, orgId: $orgId }) {
      url
    }
  }
`;

export const SUPPORTER_CHECKOUT_TICKET = gql`
  mutation supporterCheckoutTicket($ticketId: ID!, $supporterId: ID!) {
    supporterCheckoutTicket(
      input: { ticketId: $ticketId, supporterId: $supporterId }
    ) {
      url
    }
  }
`;
